// extracted by mini-css-extract-plugin
export default {"main_nav":"index_main_nav_Ck3LE","user":"index_user_Nhbno","box":"index_box_zQuqc","ad":"index_ad_n8-cj","search":"index_search_V6Anw","logo":"index_logo_cHS10"};